// import "bootstrap/dist/css/bootstrap.min.css"
//ARABIC
import React , { useState, useEffect } from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
// import unesco_shortcode from "../components/unesco"
import SEO from "../components/seo"
import { graphql } from "gatsby"
import { Component } from 'react'
import Chart from "chart.js";
import remark from 'remark';
import recommended from 'remark-preset-lint-recommended';
import remarkHtml from 'remark-html';
import { barChart } from "../components/charts"
import {makeChartThree} from '../components/chartThree'
import { getTitles } from "../components/getTitles"
import { getAnchors } from "../components/getanchor"
import handleScroll from '../components/paralax'
import { AnchorLink } from "gatsby-plugin-anchor-links";
import {cavaat} from "../components/cavaat"
// var drupal_base_url="https://unescoadmin.wabamedia.co/sites";
var drupal_base_url="https://www.unesco.org/reports/sjdi/2020";

  
   
const IndexPage = ({ data }) => {
  useEffect( () => {
    // barChart("chart-1", data.charts.body.value, 0);
    // barChart( "chart-2", data.charts.body.value, 1 );
    // barChart( "chart-4", data.charts.body.value, 1 );
    //  barChart( "chart-5", data.charts.body.value, 1 );
    //   barChart( "chart-6", data.charts.body.value, 1 );
    // makeChartThree("chart-3", data.charts.body.value)
    getAnchors();
    getTitles();
    handleScroll()
  
     
  }, [])

  return(
 <Layout lang='ar'> 
  
    <SEO title="Unesco"/>
      {/* SECTION 1  DESIGN*/}
<div className="ink-spill">    
    <section className="section1" id="section1">
      
{/* <h1>{data.allNodePage.edges[0].node.title}</h1> */}

    <div dangerouslySetInnerHTML={{ __html:  remark()
      .use(recommended) 
      .use(remarkHtml) 
      .processSync(data.section1.body.value).toString().replace(/\/sites/g,drupal_base_url).replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi,'') }} />
    <p></p> 
    <div style={{ maxWidth: `500px`, marginBottom: `1.45rem` }}>
    {/* <img src={data.globesketch.childImageSharp.fluid.originalImg} alt="gun sketch"/>  */}
    </div>  
      
    </section> 
    </div> 
    {/* SECTION 2  DESIGN*/}
<section className="section2_1" id="section2">
 

{/* <h1>{data.allNodePage.edges[0].node.title}</h1> */}

    <div dangerouslySetInnerHTML={{ __html:  remark()
      .use(recommended) 
      .use(remarkHtml) 
      .processSync(data.section2_1.body.value).toString().replace(/\/sites/g,drupal_base_url).replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi,'') }} />
    <p></p>
    <div style={{ maxWidth: `500px`, marginBottom: `1.45rem` }}>
    {/* <img src={data.globesketch.childImageSharp.fluid.originalImg} alt="gun sketch"/>  */}
  

    </div>
</section>
<div className="clearfix bullet-push">&nbsp;</div>
<section className="section2_2">
<div className="clearfix ">&nbsp;</div>
{/* <h1>{data.allNodePage.edges[0].node.title}</h1> */}

    <div dangerouslySetInnerHTML={{ __html:  remark()
      .use(recommended) 
      .use(remarkHtml)
      .processSync(data.section2_2.body.value).toString().replace(/\/sites/g,drupal_base_url).replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi,'') }}  />
    <p></p>
    <div style={{ maxWidth: `500px`, marginBottom: `1.45rem` }}>
    {/* <img src={data.globesketch.childImageSharp.fluid.originalImg} alt="gun sketch"/>  */}
    </div>
     
</section>
<div className="clearfix ">&nbsp;</div>
<section className="section2_3">
  <div className="reporters-top"> 

{/* <h1>{data.allNodePage.edges[0].node.title}</h1> */}
  
    <div dangerouslySetInnerHTML={{ __html:  remark()
      .use(recommended) 
      .use(remarkHtml)
      .processSync(data.section2_3.body.value).toString().replace(/\/sites/g,drupal_base_url).replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi,'') }} />
    <p></p>

   

    </div>
</section>

<div className="clearfix ">&nbsp;</div>
<section className="section2_3_0">
  <div className="">  
<div className="">
{/* <h1>{data.allNodePage.edges[0].node.title}</h1> */}
  
    <div dangerouslySetInnerHTML={{ __html:  remark()
      .use(recommended) 
      .use(remarkHtml)
      .processSync(data.section2_3_0.body.value).toString().replace(/\/sites/g,drupal_base_url).replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi,'') }}  />
    <p></p>

    <div style={{ maxWidth: `500px`, marginBottom: `1.45rem` }}>
    {/* <img src={data.globesketch.childImageSharp.fluid.originalImg} alt="gun sketch"/>  */}
    </div>
    </div>  
    </div>
</section>

<div className="clearfix ">&nbsp;</div>
<section className="section2_3_1">
<div className="reporters-top"> 

{/* <h1>{data.allNodePage.edges[0].node.title}</h1> */}
  
    <div dangerouslySetInnerHTML={{ __html:  remark()
      .use(recommended) 
      .use(remarkHtml)
      .processSync(data.section2_3_1.body.value).toString().replace(/\/sites/g,drupal_base_url).replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi,'')  }} />
    <p></p>
    <div style={{ maxWidth: `500px`, marginBottom: `1.45rem` }}>
    {/* <img src={data.globesketch.childImageSharp.fluid.originalImg} alt="gun sketch"/>  */}
    </div>
  
    </div>
</section>
      <div className="clearfix ">&nbsp;</div>
      
      <div id="chart-3"></div>
  {/* SECTION 2  DESIGN*/}
  <section className="section2_4">
<div className="row"> 

{/* <h1>{data.allNodePage.edges[0].node.title}</h1> */}

    <div dangerouslySetInnerHTML={{ __html:  remark()
      .use(recommended) 
      .use(remarkHtml) 
      .processSync(data.section2_4.body.value).toString().replace(/\/sites/g,drupal_base_url).replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi,'') }} />
    <p></p>
    <div style={{ maxWidth: `500px`, marginBottom: `1.45rem` }}>
    {/* <img src={data.globesketch.childImageSharp.fluid.originalImg} alt="gun sketch"/>  */}
    
    </div>  
    </div>
</section>
<div className="clearfix">&nbsp;</div>
<div className="clearfix ">&nbsp;</div>
<section className="section3" id="section3">
<div dangerouslySetInnerHTML={{ __html:  remark()
      .use(recommended) 
      .use(remarkHtml) 
      .processSync(data.section3.body.value).toString().replace(/\/sites/g,drupal_base_url).replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi,'') }} />
</section>
<section className="section3_1">
<div dangerouslySetInnerHTML={{ __html:  remark()
      .use(recommended) 
      .use(remarkHtml) 
      .processSync(data.section3_1.body.value).toString().replace(/\/sites/g,drupal_base_url).replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi,'') }} />
</section>

<section className="section3_2">
<div dangerouslySetInnerHTML={{ __html:  remark()
      .use(recommended) 
      .use(remarkHtml) 
      .processSync(data.section3_2.body.value).toString().replace(/\/sites/g,drupal_base_url).replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi,'') }} />
</section>


<section className="section3_3_1">
<div dangerouslySetInnerHTML={{ __html:  remark()
      .use(recommended) 
      .use(remarkHtml) 
      .processSync(data.section3_3_1.body.value).toString().replace(/\/sites/g,drupal_base_url).replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi,'') }} />
</section>

<section className="section3_3_2">
<div dangerouslySetInnerHTML={{ __html:  remark()
      .use(recommended) 
      .use(remarkHtml) 
      .processSync(data.section3_3_2.body.value).toString().replace(/\/sites/g,drupal_base_url).replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi,'') }} />
</section>

<section className="section3_3_3">
<div dangerouslySetInnerHTML={{ __html:  remark()
      .use(recommended) 
      .use(remarkHtml) 
      .processSync(data.section3_3_3.body.value).toString().replace(/\/sites/g,drupal_base_url).replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi,'') }} />
</section>

<section className="notes">
<div dangerouslySetInnerHTML={{ __html:  remark()
      .use(recommended) 
      .use(remarkHtml) 
      .processSync(data.notes.body.value).toString().replace(/\/sites/g,drupal_base_url).replace(/(style=")([a-zA-Z0-9:;\.\s\(\)\-\,]*)(")/gi,'') }} />
      </section>
</Layout>
)
}




export const query = graphql`
  {
    globesketch: file(relativePath: { eq: "npm" }) {
      childImageSharp {
        id
        fluid {
          originalName
          originalImg
        }
      }
    }
    reportersketch: file(relativePath: { eq: "reporter-sketch.png" }) {
      childImageSharp {
        id
        fluid {
          originalName
          originalImg
        }
      }
    }
    gavelsketch: file(relativePath: { eq: "gavel-sketch.png" }) {
      childImageSharp {
        id
        fluid {
          originalName
          originalImg
        }
      }
    }
    gunsketch: file(relativePath: { eq: "gun-sketch.png" }) {
      childImageSharp {
        id
        fluid {
          originalName
          originalImg
        }
      }
    }
    section1: nodePage(title: { eq: "ar-Section1" }) {
      body {
        value
      }
      title 
    }
 

    section2_1: nodePage(title: { eq: "ar-Section2-1" }) {
      body {
        value
      }
      title
    }
    section2_2: nodePage(title: { eq: "ar-Section2-2" }) {
      body {
        value
      }
      title
    }
    section2_3: nodePage(title: { eq: "ar-Section2-3" }) {
      body {
        value
      }
      title
    }
    section2_3_0: nodePage(title: { eq: "ar-Section2-3-0" }) {
      body {
        value
      }
      title
    }
    section2_3_1: nodePage(title: { eq: "ar-Section2-3-1" }) {
      body {
        value
      }
      title
    }
    section2_4: nodePage(title: { eq: "ar-Section2-4" }) {
      body {
        value
      }
      title
    }
    section3: nodePage(title: { eq: "ar-Section3" }) {
      body {
        value
      }
      title
    }
    section3_1: nodePage(title: { eq: "ar-Section3-1" }) {
      body {
        value
      }
      title
    }
    section3_2: nodePage(title: { eq: "ar-Section3-2" }) {
      body {
        value
      }
      title
    }
   
    section3_3_1: nodePage(title: { eq: "ar-Section3-3-1" }) {
      body {
        value
      }
      title
    }
     section3_3_2: nodePage(title: { eq: "ar-Section3-3-2" }) {
      body {
        value
      }
      title
    }
    section3_3_3: nodePage(title: { eq: "ar-Section3-3-3" }) {
      body {
        value
      }
      title
    }
    notes: nodePage(title: { eq: "ar-Notes" }) {
      body {
        value
      }
      title
    }
    charts: nodePage(title: { eq: "charts-json" }) {
      body {
        value
      }
      title
    }
  
}
`

function fixHeight (){
  console.log("ok go ")
  var x = document.getElementsByClassName("section2_3");
  var x_child = document.getElementsByClassName("special-bg");
  x.style.height =  x.style.height+x_child.height;

}


export default IndexPage

